<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     账户中心-一物一码
  +---------------------------------------------------------------------------------------
-->

<template>
  <div class="fam-code">
    <div class="flex align-items-center mt">
      <el-tabs v-model="activeTab" class="bd" @tab-click="switchTab">
        <el-tab-pane label="二维码管理" name="qrcode"></el-tab-pane>
        <el-tab-pane label="商品管理" name="product"></el-tab-pane>
      </el-tabs>
      <div v-if="inited && (code_total || product_total)" class="ft">
        <el-button icon="iconfont icon-qr" type="success" @click="qrcodeCreat">生成二维码</el-button>
        <el-button icon="el-icon-plus" type="success" @click="editProduct()">新商品</el-button>
      </div>
    </div>

    <template v-if="inited && !code_total && !product_total">
      <el-card shadow="never" class="mt-md">
        <div class="flex" style="width:900px;margin: 65px auto;">
          <div class="hd" style="width: 450px;line-height: 1.8;">
            <div class="font-2x text-bold mt-md">一物一码</div>
            <div class="mt-lg">功能介绍</div>
            <div class="mt-sm text-muted">通过“一物一码”（One Item One Code）技术，对商家销售的产品/零配件/耗材等商品进行赋码管理，帮助商家解决品牌的防伪、溯源、营销、数字化经营等难题。</div>
            <div class="mt-lg">使用条件</div>
            <div class="text-muted">必须开通企业版</div>
            <div class="mt-lg">使用流程</div>
            <div class="mt-sm text-muted">
              01、商品信息维护<br />
              02、生成二维码<br />
              03、下载二维码<br />
              04、激活赋值<br />
              05、扫码核验
            </div>
            <el-button type="success" class="mt-lg" @click="editProduct()">新建第一个商品</el-button>
          </div>
          <div class="bd" />
          <div class="ft preview"></div>
        </div>
      </el-card>
    </template>

    <template v-if="inited && (code_total || product_total)">
      <template v-if="activeTab == 'qrcode'">
        <div class="filter-container">
          <div class="filter-box">
            <span class="filter-item">
              <f-radio-btn-group v-model="query.status" :groups="statusTypeArr" @change="fetchData(1)" />
            </span>
            <div class="filter-item">
              <product-selector v-model="query.productid" width="200" @change="fetchData(1)" />
            </div>
            <div class="filter-item sm">
              <el-input v-model="query.keyword" placeholder="序列 / 编码" prefix-icon="el-icon-search" clearable @change="fetchData(1)" />
            </div>
          </div>

          <div class="toolbox">
            <f-sort-selector v-model="query.sort" :options="sortOptions" class="ml-sm" @change="fetchData(1)" />
          </div>
        </div>
        <el-card v-loading="loading" shadow="never">
          <el-table ref="qrcodeTable" key="qrcode" :data="qrcodeList" tooltip-effect="dark" class="padding-small" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="50" />
            
            <el-table-column :show-overflow-tooltip="true" label="序列" min-width="80">
              <template slot-scope="scope">
                <span>{{ scope.row.serial_no }}</span>
              </template>
            </el-table-column>
            <el-table-column width="50" align="center">
              <template slot-scope="scope">
                <el-image class="image rounded" :src="scope.row.code_url" fit="cover" :preview-src-list="[scope.row.code_url]"></el-image>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip label="编码" min-width="180">
              <template slot-scope="scope">
                <span>{{ scope.row.code }}</span>
              </template>
            </el-table-column>

            <el-table-column show-overflow-tooltip label="状态" min-width="120">
              <template slot-scope="scope">
                <div class="flex align-items-center">
                  <div class="dot" :class="scope.row.status == 2 ? 'bg-primary' : (scope.row.status == 3 ? 'bg-warning' : (scope.row.status == 4 ? 'bg-danger' : 'bg-grey'))" />
                  <div class="ml-xs">{{ scope.row.status == 2 ? '已激活' : (scope.row.status == 3 ? '已查验' : (scope.row.status == 4 ? '已核销' : '未激活')) }}</div>
                  <el-button v-if="scope.row.status == 4" type="text" class="ml-sm hover-show" @click="toReset(scope.row)">重置</el-button>
                </div>
              </template>
            </el-table-column>

            <el-table-column width="50" align="center">
              <template slot-scope="scope">
                <el-image v-if="scope.row.productid" class="image rounded" :src="scope.row.thumb_url" fit="cover" :preview-src-list="[scope.row.thumb_url]"></el-image>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip label="商品" min-width="200">
              <template slot-scope="scope">
                <div v-if="scope.row.productid">{{ scope.row.brand + '; ' + scope.row.name + '; ' + scope.row.model }}</div>
                <div v-if="scope.row.product_date" class="text-muted font-12">生产日期 {{ scope.row.product_date | parseTime('{y}/{m}/{d}') }}</div>
              </template>
            </el-table-column>

            <el-table-column label="创建时间" show-overflow-tooltip min-width="140">
              <template slot-scope="scope">
                <span>{{ scope.row.createtime | parseTime('{y}/{m}/{d} {h}:{i}') }}</span>
              </template>
            </el-table-column>
            <el-table-column label="激活时间" show-overflow-tooltip min-width="140">
              <template slot-scope="scope">
                <span>{{ scope.row.activate_time | parseTime('{y}/{m}/{d} {h}:{i}') }}</span>
              </template>
            </el-table-column>
            <el-table-column label="查验时间" show-overflow-tooltip min-width="140">
              <template slot-scope="scope">
                <span>{{ scope.row.last_check_time | parseTime('{y}/{m}/{d} {h}:{i}') }}</span>
              </template>
            </el-table-column>
            <el-table-column label="核销时间" show-overflow-tooltip min-width="140">
              <template slot-scope="scope">
                <span v-if="scope.row.verify_enable">{{ scope.row.verify_time | parseTime('{y}/{m}/{d} {h}:{i}') }}</span>
                <span v-if="scope.row.status > 1 && !scope.row.verify_enable">{{ '不支持核销' }}</span>
              </template>
            </el-table-column>

            <el-table-column width="120" label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click="toDeleteQr(scope.row)">删除</el-button>
                <el-button v-if="scope.row.last_check_time" type="text" @click="toView(scope.row)">查验记录</el-button>
              </template>
            </el-table-column>
            <div slot="empty" class="flex-center column pb-md">
              <div class="flex-center mt-hg">
                <img src="@/assets/no-data.png" alt="" class="no-data">
              </div>
            </div>
          </el-table>
        </el-card>
        <div v-if="total" class="foot" :class="!collapse && 'active'">
          <f-table-footer :list="qrcodeList" :selection="multiSelection" @toggle="toggleAll" checkbox>
            <el-button type="success" size="mini" plain @click="toDownload()">下载</el-button>
            <el-button type="success" size="mini" plain @click="toActive">激活</el-button>
            <el-button type="success" size="mini" :disabled="multiSelection.length === 0" plain @click="deleteAll">删除</el-button>
            <template slot="right">
              <f-pagination :total="total" :pindex.sync="query.pindex" :psize.sync="query.psize" @change="fetchData" />
            </template>
          </f-table-footer>
        </div>
      </template>

      <template v-if="activeTab == 'product'">
        <div class="filter-container">
          <div class="filter-box">
            <div class="filter-item" style="width: 160px;">
              <el-input v-model="productQuery.keyword" placeholder="搜索" prefix-icon="el-icon-search" clearable @change="fetchProduct(1)" />
            </div>
          </div>
        </div>
        <el-card v-loading="loading" shadow="never">
          <el-table ref="productTable" key="product" :data="productList" tooltip-effect="dark" class="padding-small">
            <el-table-column width="60" type="index" label="#" />

            <el-table-column width="50" align="center">
              <template slot-scope="scope">
                <el-image class="image rounded" :src="scope.row.thumb_url" fit="cover" :preview-src-list="[scope.row.thumb_url]"></el-image>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip label="商品" min-width="160">
              <template slot-scope="scope">
                <span>{{ scope.row.name }}</span>
              </template>
            </el-table-column>

            <el-table-column show-overflow-tooltip label="品牌" min-width="120">
              <template slot-scope="scope">
                <span>{{ scope.row.brand }}</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip label="型号" min-width="120">
              <template slot-scope="scope">
                <span>{{ scope.row.model }}</span>
              </template>
            </el-table-column>

            <el-table-column show-overflow-tooltip label="总数 / 已核销" min-width="120">
              <template slot-scope="scope">
                <span>{{ scope.row.total_count + ' / ' + scope.row.verify_count }}</span>
              </template>
            </el-table-column>

            <el-table-column label="支持核销" show-overflow-tooltip min-width="120">
              <template slot-scope="scope">
                <div class="flex align-items-center">
                  <el-switch v-model="scope.row.verify_enable" :active-value="1" :inactive-value="0" disabled />
                  <div v-if="scope.row.verify_enable && scope.row.verify_value" class="remark text-white ml-xs">{{ scope.row.verify_value }}</div>
                </div>
              </template>
            </el-table-column>

            <el-table-column width="120" label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click="editProduct(scope.row)">编辑</el-button>
                <el-button type="text" @click="toDeletePr(scope.row)">删除</el-button>
              </template>
            </el-table-column>

            <div slot="empty" class="flex-center column pb-md">
              <div class="flex-center mt-hg">
                <img src="@/assets/no-data.png" alt="" class="no-data">
              </div>
            </div>
          </el-table>
        </el-card>
        <div v-if="productTotal" class="foot" :class="!collapse && 'active'">
          <f-table-footer>
            <template slot="right">
              <f-pagination :total="productTotal" :pindex.sync="productQuery.pindex" :psize.sync="productQuery.psize" @change="fetchProduct" />
            </template>
          </f-table-footer>
        </div>
      </template>
    </template>

    <qrcode-create v-if="qrcodeCreateShow" :show.sync="qrcodeCreateShow" :num="num" @success="qrcodeUpdate(1)" @download="toDownload" />

    <qrcode-download v-if="qrcodeDownloadShow" :show.sync="qrcodeDownloadShow" :start="start" :end="end" />

    <qrcode-active v-if="qrcodeActiveShow" :show.sync="qrcodeActiveShow" @success="fetchData" />

    <qrcode-check v-if="checkShow" :show.sync="checkShow" :qr="activeQr" @success="fetchData" />

    <product-edit v-if="productEditShow" :show.sync="productEditShow" :product="activeProduct" @success="productUpdate" />

    <product-delete v-if="productDeleteShow" :show.sync="productDeleteShow" :product="activeProduct" @success="productUpdate" />
  </div>
</template>

<script>
import { overviewApi, productListApi, codeListApi, codeDeleteApi, codeResetApi } from "@/api/fam/famCodeApi";

export default {
  name: 'FamCode',

  components: {
    ProductSelector: () => import('./components/ProductSelector.vue'),
    QrcodeCreate: () => import('./components/QrcodeCreate.vue'),
    QrcodeDownload: () => import('./components/QrcodeDownload.vue'),
    QrcodeActive: () => import('./components/QrcodeActive.vue'),
    QrcodeCheck: () => import('./components/QrcodeCheck.vue'),
    ProductEdit: () => import('./components/ProductEdit.vue'),
    ProductDelete: () => import('./components/ProductDelete.vue'),
  },

  data() {
    return {
      inited: false,
      code_total: 0,
      product_total: 0,
      productEditShow: false,
      productDeleteShow: false,
      qrcodeActiveShow: false,
      checkShow: false,
      activeQr: {},
      activeProduct: {},
      qrcodeCreateShow: false,
      num: 100,
      activeTab: 'qrcode',

      sortOptions: [
        { value: 1, title: "序列降序" },
        { value: 2, title: "序列升序" },
        { value: 3, title: "最近创建" },
        { value: 4, title: "最近激活" },
        { value: 5, title: "最近查验" },
        { value: 6, title: "最近核销" },
      ],
      multiSelection: [],
      loading: false,
      query: {
        keyword: null,
        status: 0,
        sort: 1,
        pindex: 1,
        psize: this.$store.state.commonStore.psize,
        productid: null,
      },

      statusTypeArr: [
        { value: 0, title: "全部", separate: true },
        { value: 1, title: "未激活" },
        { value: 2, title: "已激活" },
        { value: 3, title: "已查验" },
        { value: 4, title: "已核销" },
      ],

      productQuery: {
        keyword: null,
        pindex: 1,
        psize: this.$store.state.commonStore.psize,
      },

      qrcodeList: [],
      productList: [],
      total: 0,
      productTotal: 0,

      qrcodeDownloadShow: false,
      start: null,
      end: null
    }
  },

  computed: {
    aiot_version() {
      return this.$store.state.godStore.aiot_version
    },

    collapse() {
      return this.$store.state.commonStore.collapse
    },
  },


  created() {
    this.fetchOverview()
    this.fetchData(1, true)
  },

  methods: {
    switchTab(val) {
      if (this.activeTab == 'qrcode') this.fetchData(1, true)
      if (this.activeTab == 'product') this.fetchProduct(1, true)
    },

    toggleAll() {
      this.$refs.qrcodeTable.toggleAllSelection();
    },

    fetchOverview() {
      overviewApi().then((res) => {
        if (res.errno === 0) {
          this.code_total = res.data.code_total
          this.product_total = res.data.product_total
          this.inited = true
        } else {
          this.$message.error(res.message)
        }
      })
    },

    fetchProduct(page, loading) {
      if (page) this.productQuery.pindex = page
      if (loading) this.loading = true
      productListApi(this.productQuery).then((res) => {
        this.loading = false
        if (res.errno === 0) {
          this.productList = res.data.list
          this.productTotal = res.data.total
        } else {
          this.$message.error(res.message)
        }
      })
    },

    fetchData(page, loading) {
      if (page) this.query.pindex = page
      if (loading) this.loading = true
      codeListApi(this.query).then((res) => {
        this.loading = false
        if (res.errno === 0) {
          this.qrcodeList = res.data.list
          this.total = res.data.total
        } else {
          this.$message.error(res.message)
        }
      })
    },

    handleSelectionChange(val) {
      this.multiSelection = val;
    },

    qrcodeCreat() {
      if (this.aiot_version == 0) {
        this.alertVersion()
        return
      }
      this.qrcodeCreateShow = true
    },

    editProduct(item) {
      if (this.aiot_version == 0) {
        this.alertVersion()
        return
      }
      this.activeProduct = Object.assign({}, item)
      this.productEditShow = true
    },

    alertVersion() {
      // this.$alert('该功能仅针对企业版用户开放，立即升级，尊享更多服务特权！', '提示', {
      //   type: 'warning',
      //   showCancelButton: true,
      //   confirmButtonText: '立即升级',
      //   callback: (action) => {
      //     if (action == 'confirm') this.$router.push("/home/upgrade")
      //   }
      // })
    },

    toDeleteQr(row) {
      this.$confirm(`此操作将删除序列为 <span class="text-danger">${row.serial_no}</span> 的二维码，是否继续？`, '警告', {
        dangerouslyUseHTMLString: true,
        type: 'error'
      }).then(() => {
        this.codeDelete([row.codeid])
      }).catch(() => {
      })
    },

    deleteAll() {
      const codeids = this.multiSelection.map(i => i.codeid)
      this.$confirm(`此操作将删除选中的 <span class="text-danger">${codeids.length}</span> 个二维码，是否继续？`, '警告', {
        dangerouslyUseHTMLString: true,
        type: 'error'
      }).then(() => {
        this.codeDelete(codeids)
      }).catch(() => {
      })
    },

    codeDelete(codeids) {
      this.loading = true
      codeDeleteApi({ codeids: codeids }).then((res) => {
        this.loading = false
        if (res.errno === 0) {
          this.$message.success('二维码删除成功！')
          this.qrcodeUpdate()
        } else {
          this.$message.error(res.message)
        }
      })
    },

    toView(row) {
      this.activeQr = Object.assign({}, row)
      this.checkShow = true
    },

    toActive() {
      this.qrcodeActiveShow = true
    },

    toReset(row) {
      this.$confirm(`此操作将重置序列为 <span class="text-danger">${row.serial_no}</span> 的二维码，是否继续？`, '提示', {
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).then(() => {
        codeResetApi({ codeid: row.codeid }).then((res) => {
          if (res.errno === 0) {
            this.$message.success('二维码重置成功！')
            this.fetchData()
          } else {
            this.$message.error(res.message)
          }
        })
      }).catch(() => {
      })
    },

    toDownload(e) {
      this.start = e ? e.start_serial_no : 0
      this.end = e ? e.end_serial_no : 0
      setTimeout(() => {
        this.qrcodeDownloadShow = true
      }, 200)
    },

    toDeletePr(row) {
      this.activeProduct = Object.assign({}, row)
      this.productDeleteShow = true
    },

    qrcodeUpdate(page) {
      if (page) this.activeTab = 'qrcode'
      this.fetchData(page)
      this.fetchOverview()
    },

    productUpdate() {
      this.activeTab = 'product'
      this.fetchProduct()
      this.fetchOverview()
    }
  }
}
</script>

<style lang="scss" scoped>
.fam-code {
  padding-bottom: 70px;
  /deep/ .el-tabs__header {
    margin: 0 0 0;
  }
  /deep/ .el-tabs__nav-wrap::after {
    height: 0;
    background-color: transparent
  }
  /deep/ .el-tabs__item {
    font-size: 18px;
    font-weight: bolder;
  }
  .foot {
    position: fixed;
    background-color: #fff;
    bottom: 0;
    left: 240px;
    width: calc(100% - 240px);
    padding-left: 38px;
    z-index: 99;
    &.active {
      left: 340px;
      width: calc(100% - 340px);
    }
  }
  .dot {
    width: 16px;
    height: 16px;
    border-radius: 50%;
  }
  .remark {
    height: 20px;
    line-height: 20px;
    border-radius: 4px;
    background-color: #ccc;
    padding: 0 10px;
  }

  .preview {
    width: 273px;
    height: 590.8px;
    background-size: 100% 100%;
    background-image: url("../../assets/oioc-code-preview.jpg");
  }
}
</style>
